import { queryOptions } from "@tanstack/react-query";
import { apiBase, apiUrl } from "@/lib/api-url";

export const pagesQueryOptions = (filters?: {
  status?: string;
  locale?: string;
  page?: number;
  limit?: number;
}) =>
  queryOptions({
    queryKey: ["pages", filters],
    queryFn: async () => {
      const url = new URL("/api/pages", apiBase());
      if (filters?.status) url.searchParams.set("status", filters.status);
      if (filters?.locale) url.searchParams.set("locale", filters.locale);
      if (filters?.page) url.searchParams.set("page", String(filters.page));
      if (filters?.limit) url.searchParams.set("limit", String(filters.limit));
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch pages");
      return res.json();
    },
  });

export const pageQueryOptions = (slug: string, locale?: string) =>
  queryOptions({
    queryKey: ["pages", slug, locale],
    queryFn: async () => {
      const url = new URL(`/api/pages/${slug}`, apiBase());
      if (locale) url.searchParams.set("locale", locale);
      const res = await fetch(url);
      if (!res.ok) throw new Error("Page not found");
      return res.json();
    },
  });

export const pageByIdQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["pages", "by-id", id],
    queryFn: async () => {
      const res = await fetch(apiUrl(`/api/pages/page/${id}`));
      if (!res.ok) throw new Error("Page not found");
      return res.json();
    },
  });
